import _implicitStylesheets from "./pricingSummary.css";
import _implicitScopedStylesheets from "./pricingSummary.scoped.css?scoped=true";
import _wdsLink from "wds/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div data-testid="pricing-summary-headline"${3}><b type-style="display-6"${3}>${"t2"}</b> <b type-style="body-2"${3}>${"t5"}</b></div>`;
const $fragment2 = parseFragment`<div type-style="body-3" data-testid="pricing-summary-description"${3}><p${3}>${"t2"}</p></div>`;
const stc0 = {
  classMap: {
    "pricing-summary": true
  },
  attrs: {
    "grid": "",
    "axis": "column"
  },
  key: 0
};
const stc1 = {
  attrs: {
    "type-style": "body-3"
  },
  key: 5
};
const stc2 = {
  "data-testid": "pricing-summary-link"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, b: api_bind, c: api_custom_element, h: api_element} = $api;
  const {_m0} = $ctx;
  return [api_element("div", stc0, [api_static_fragment($fragment1, 2, [api_static_part(2, null, " " + api_dynamic_text($cmp.summaryHeadline) + " "), api_static_part(5, null, " " + api_dynamic_text($cmp.summaryHeadlinePaidPlanDetails) + " ")]), $cmp.summaryDescription ? api_static_fragment($fragment2, 4, [api_static_part(2, null, api_dynamic_text($cmp.summaryDescription))]) : null, api_element("div", stc1, [api_custom_element("wds-link", _wdsLink, {
    attrs: stc2,
    props: {
      "i18nMessage": $cmp.pricingDetailsUrlLabel,
      "name": "pricing details"
    },
    key: 6,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleI18nLinkClick))
    }
  })])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-63ekucr46kf";
tmpl.legacyStylesheetToken = "undefined-_pricingSummary";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
